// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1IOE2","row":"Node_row__2Xk5Q","label":"Node_label__1tlGu","footer":"Node_footer__1WyJg"};